import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HttpCancelService {
  private cancelPending$ = new Subject<void>();

  get onCancel$() { return this.cancelPending$.asObservable(); }

  cancelAll() { this.cancelPending$.next(); }
}
